export const getCookie = (cookieName: string) => {
  const match = document.cookie.match(new RegExp(`${cookieName}=([^;]+)`));

  return match ? match[1] : undefined;
};
